import PraisoServices from "./PraisoServices";
import { getToken, getAPIResponse, setAPIResponse, getUserData } from "./LocalStorageService";
import { APIURL, DragNDrop, RBAC_CODE, Role, TransformationType, ReportedEventStatus, TableComponentCodes } from "../config/app-globals.enum";
import { getDefaultTableComponent } from "../config/app-global-method";

export const PraisoTableListAPI = async (params: any, impersonationParams: any, viewName?: any, forceRefresh?: boolean) => {
    const ApiUrl = params.apiUrl;
    let apiParam = params.apiParam;
    let url = ApiUrl;
    if (apiParam.userId) {
        //Event details for user
        url = `${ApiUrl}?${apiParam.userId}`;
    } else if (apiParam.eventTypeId) {
        //For event details
        url = `${ApiUrl}?${apiParam.eventTypeId}`;
    } else {
        //For wol and content
        url = `${ApiUrl}?${apiParam.isShowAllDrivers}`;
    }

    if (impersonationParams.impersonationid) {
        apiParam['impersonationId'] = impersonationParams.impersonationid;
        url = `${url}&${impersonationParams.impersonationid}`;
    }
    const token = getToken();
    try {
        if (!forceRefresh) {
            const data = getAPIResponse(url);
            if (data !== null) {
                return data;
            }
        }
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {
                ...apiParam,
            },
            {
                Authorization: `Bearer ${token}`,
            }
        );
        try {
            setAPIResponse(url, response);
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const getPraisoTableList = async (params: any, impersonationParams?: any) => {
    const data = await PraisoTableListAPI(params, impersonationParams);
    return data;
    // if (
    //     data.status.code !== 0 &&
    //     data.status.code !== 200 &&
    //     data.status.code !== 201
    // ) {
    //     return data;
    // } else {
    //     return data;
    // }
};

export const getPraisoTableData = async (params: any, impersonationParams: any, viewName: any, forceRefresh?: boolean) => {
    const data = await PraisoTableListAPI(params, impersonationParams, viewName, forceRefresh);
    return data;
    // if (
    //     data.status.code !== 0 &&
    //     data.status.code !== 200 &&
    //     data.status.code !== 201
    // ) {
    //     return data;
    // } else {
    //     return data;
    // }
};

export const GetPraisoTableSettingsAPI = async (url: string) => {
    const ApiUrl = url;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "get", {}, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
}

async function getTableSettings(userData: any, url: string, t: any, params: any) {
    let data = {
        status: {
            code: 0,
            message: "success",
        },
        content: null,
    };
    const placeholder = `${t("SEARCH_FROM")} {{value}} ${t("DRIVER")}`;
    data = await GetPraisoTableSettingsAPI(url);
    if ((data.status.code === 0 || data.status.code === 200 || data.status.code === 201) && data.content) {
        const tableConfiguration = data.content.tableConfig;
        const tcViewArray = data.content.tcViewArray;
        //Get default component ID
        const viewId = getDefaultTableComponent(tcViewArray);
        data.content = [];
        for (let i = 0; i < tcViewArray.length; i++) {
            let tableConfig: any = {};
            let customTable: any = {};
            let columns = [];
            let selectedColumns = [];
            const tcView = tcViewArray[i];
            const viewConfig = tcView.viewConfig;
            customTable.id = tcView.tcViewId;
            if (tcView.isSystemDefault) {
                customTable.tableName = t(tcView.viewName);
            } else {
                customTable.tableName = tcView.viewName;
            }
            customTable.isFavourite = viewId === tcView.tcViewId ? true : false;
            customTable.isDefault = viewId === tcView.tcViewId ? true : false;
            customTable.isSystemDefault = tcView.isSystemDefault ? true : false;
            tableConfig.defaultPageSize = viewConfig.pagination.defaultPageSize;
            tableConfig.globalFilterPlaceholder = placeholder;
            tableConfig.isAccordionEnable = true;
            // tableConfig.isAccordionEnable = tableConfiguration.isAccordionEnable;
            tableConfig.isGlobalFilterEnable = tableConfiguration.isGlobalFilterEnable;
            tableConfig.isGroupByEnable = tableConfiguration.isGroupByEnable;
            tableConfig.pageLengthArray = tableConfiguration.pageLengthArray;
            tableConfig.showPagination = viewConfig.pagination.isShowPagination === 1 ? true : false;
            for (let j = 0; j < tableConfiguration.columns.length; j++) {
                let tableColumn = Object.assign({}, tableConfiguration.columns[j]);
                const selectColumn = viewConfig.columnList.filter((col) => {
                    return col.columnCode === tableColumn.columnCode;
                });
                if (selectColumn.length !== 0) {
                    selectedColumns.push(tableColumn.propertyName);
                    tableColumn.header = selectColumn[0].header;
                    tableColumn.order = selectColumn[0].order;
                    tableColumn.isRequired = selectColumn[0].isRequired;
                    const selectGroupBy = viewConfig.groupByList.filter((group) => {
                        return group.columnCode === tableColumn.columnCode;
                    });
                    if (selectGroupBy.length !== 0) {
                        tableColumn.isGrouped = true;
                    }
                    columns.push(tableColumn);
                }
            }
            tableConfig.columns = columns;
            customTable.tableConfiguration = tableConfig;
            customTable.selectColumn = selectedColumns.filter((v, i, a) => a.indexOf(v) === i); //get selected column for export data;
            data.content.push(customTable);
        }
    }
    return data.content;
}

export const getPraisoTableSettings = async (url: string, type: string, t: any, params: any) => {
    let data = {
        status: {
            code: 0,
            message: "success",
        },
        content: null,
    };
    const placeholder = `${t("SEARCH_FROM")} {{value}} ${t("DRIVER")}`;
    const userData = getUserData();
    if (type === TableComponentCodes.WALL_OF_LEGEND) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) { //@todo Check allowed or not
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("WALL_OF_LEGENDS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: true,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: "ScoreColorMarker",
                                isHeaderShow: false,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 5,
                                        padding: 0,
                                    },
                                    column: {
                                        position: "relative",
                                    },
                                },
                                columnCode: "scoreMarker"
                            },
                            {
                                header: "NameAvatar",
                                isHeaderShow: false,
                                propertyName: "fullName",
                                isAvatar: true,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 2,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        textAlign: "center",
                                    },
                                },
                                columnCode: "NameAvatar"
                            },
                            {
                                header: "RankTrend",
                                isHeaderShow: false,
                                propertyName: "rankTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "RankTrend"
                            },
                            {
                                header: "PraisoRank",
                                isHeaderShow: true,
                                propertyName: "rank",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 4,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: true,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                aggregate: {
                                    type: "uniqueCount",
                                    label: "Unique rank is {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "Rank"
                            },
                            {
                                header: "Name",
                                isHeaderShow: true,
                                propertyName: "fullName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 5,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                },
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: {
                                    type: "uniqueCount",
                                    label: "Unique name count {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "FullName"
                            },
                            {
                                header: "ScoreTrend",
                                isHeaderShow: false,
                                propertyName: "scoreTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                order: 6,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "ScoreTrend"
                            },
                            {
                                header: "DriverScore",
                                isHeaderShow: true,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "scoreTrend",
                                order: 7,
                                isFilterable: false, // column filter enable disable
                                isSortable: true, // column sortin enable disable
                                isSorted: false, // column by default sorted or not
                                sortedOrder: 0, // column sort by assending / discending
                                isGrouped: false, // column is group by or not
                                disableGroupBy: false, // can column group by or not
                                aggregate: {
                                    type: "average",
                                    label: "Avg. Score is {{value}}",
                                    labelEnabled: false,
                                },
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 20,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "Score"
                            },
                        ],
                    },
                },
                {
                    id: "2",
                    tableName: t("GROUP_BY_SCORE"),
                    isFavourite: true,
                    isDefault: false,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: true,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: "ScoreColorMarker",
                                isHeaderShow: false,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 5,
                                        padding: 0,
                                    },
                                    column: {
                                        position: "relative",
                                    },
                                },
                                columnCode: "scoreMarker"
                            },
                            {
                                header: "NameAvatar",
                                isHeaderShow: false,
                                propertyName: "fullName",
                                isAvatar: true,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 2,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        textAlign: "center",
                                    },
                                },
                                columnCode: "NameAvatar"
                            },
                            {
                                header: "RankTrend",
                                isHeaderShow: false,
                                propertyName: "rankTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "RankTrend"
                            },
                            {
                                header: "PraisoRank",
                                isHeaderShow: true,
                                propertyName: "rank",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 4,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: true,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                aggregate: {
                                    type: "uniqueCount",
                                    label: "Unique rank is {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "Rank"
                            },
                            {
                                header: "Name",
                                isHeaderShow: true,
                                propertyName: "fullName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 5,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                },
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: {
                                    type: "uniqueCount",
                                    label: "Unique name count {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "FullName"
                            },
                            {
                                header: "ScoreTrend",
                                isHeaderShow: false,
                                propertyName: "scoreTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                order: 6,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "ScoreTrend"
                            },
                            {
                                header: "DriverScore",
                                isHeaderShow: true,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "scoreTrend",
                                order: 7,
                                isFilterable: false, // column filter enable disable
                                isSortable: true, // column sortin enable disable
                                isSorted: false, // column by default sorted or not
                                sortedOrder: 0, // column sort by assending / discending
                                isGrouped: true, // column is group by or not
                                disableGroupBy: false, // can column group by or not
                                aggregate: {
                                    type: "average",
                                    label: "Avg. Score is {{value}}",
                                    labelEnabled: false,
                                },
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 20,
                                        fontWeight: 500,
                                    },
                                },
                                columnCode: "Score"
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.CONTENT_ENGAGEMENT) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "3",
                    tableName: t("CONTENT_ENGAGEMENT"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: true,
                        showPagination: true,
                        columns: [
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 8,
                                        padding: 0,
                                    },
                                    column: {
                                        position: "relative",
                                    },
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "fullName",
                                isAvatar: true,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 120,
                                    },
                                    column: {
                                        textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "rankTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 2,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: {
                                    type: "count",
                                    label: "Count {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Eng.Rank"),
                                isHeaderShow: true,
                                propertyName: "rank",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 2,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: true,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 20,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Name"),
                                isHeaderShow: true,
                                propertyName: "fullName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 3,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    linkParamAppend: "#ENGAGEMENT",
                                },
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_ContentActive"),
                                isHeaderShow: true,
                                propertyName: "activeContent",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 4,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_ContentSent"),
                                isHeaderShow: true,
                                propertyName: "sentContent",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 4,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "scoreTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                order: 6,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: {
                                    type: "count",
                                },
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Eng.Score"),
                                isHeaderShow: true,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "scoreTrend",
                                order: 6,
                                isFilterable: false, // column filter enable disable
                                isSortable: true, // column sortin enable disable
                                isSorted: false, // column by default sorted or not
                                sortedOrder: 0, // column sort by assending / discending
                                isGrouped: false, // column is group by or not
                                disableGroupBy: true, // can column group by or not
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                aggregate: {
                                    type: "average",
                                    label: "Avg. Score is {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 20,
                                        fontWeight: 500,
                                    },
                                },
                            },
                        ],
                    },
                },
                {
                    id: "4",
                    tableName: t("GROUP_BY_SCORE"),
                    isFavourite: true,
                    isDefault: false,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: true,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 5,
                                        padding: 0,
                                    },
                                    column: {
                                        position: "relative",
                                    },
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "fullName",
                                isAvatar: true,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 120,
                                    },
                                    column: {
                                        textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "rankTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 2,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Eng.Rank"),
                                isHeaderShow: true,
                                propertyName: "rank",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "rankTrend",
                                order: 2,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: true,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Name"),
                                isHeaderShow: true,
                                propertyName: "fullName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 3,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                },
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {},
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_ContentActive"),
                                isHeaderShow: true,
                                propertyName: "activeContent",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 4,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: {
                                    type: "sum",
                                    label: "Sum {{value}}",
                                    labelEnabled: true,
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_ContentSent"),
                                isHeaderShow: true,
                                propertyName: "sentContent",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 4,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: {
                                    type: "sum",
                                    label: "Sum {{value}}",
                                    labelEnabled: true,
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "scoreTrend",
                                isAvatar: false,
                                isTrendIcon: true,
                                order: 6,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {
                                        fontSize: 14,
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Eng.Score"),
                                isHeaderShow: true,
                                propertyName: "score",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: "scoreTrend",
                                order: 6,
                                isFilterable: false, // column filter enable disable
                                isSortable: true, // column sortin enable disable
                                isSorted: false, // column by default sorted or not
                                sortedOrder: 0, // column sort by assending / discending
                                isGrouped: true, // column is group by or not
                                disableGroupBy: false, // can column group by or not
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": "N/A"
                                    },
                                },
                                aggregate: {
                                    type: "average",
                                    label: "Avg. {{value}}",
                                    labelEnabled: false,
                                },
                                style: {
                                    header: {
                                        width: 250,
                                    },
                                    column: {
                                        fontSize: 20,
                                        fontWeight: 500,
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.SPEEDING_EVENT_USER_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("SPEEDING_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                // header: t("OCCURRED_AT"),
                                header: t("COLUMN_NAME_OccurredAt"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                isRequired: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("COLUMN_NAME_DriverName"),
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    linkParamAppend: "#SPEEDING",
                                },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                // header: t("SPEED"),
                                header: t("COLUMN_NAME_Speed"),
                                isHeaderShow: true,
                                propertyName: "speed",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                isRequired: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.BRAKING_EVENT_USER_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("BRAKING_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("COLUMN_NAME_OccurredAt"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("COLUMN_NAME_DriverName"),
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    linkParamAppend: "#BRAKING",
                                },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.CORNERING_EVENT_USER_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("CORNERING_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("COLUMN_NAME_OccurredAt"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("COLUMN_NAME_DriverName"),
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    linkParamAppend: "#CORNERING",
                                },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.ACCELERATION_EVENT_USER_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("ACCELERATION_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("COLUMN_NAME_OccurredAt"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("COLUMN_NAME_DriverName"),
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    linkParamAppend: "#ACCELERATION",
                                },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.MOBILE_DISTRACTION) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("MOBILE_DISTRACTION"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("COLUMN_NAME_OccurredAt"),
                                isHeaderShow: true,
                                propertyName: "occuredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("COLUMN_NAME_DriverName"),
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/userdetails",
                                    linkParam: "userId",
                                    //linkParamAppend: "#tabDistraction",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    linkParamAppend: "#DISTRACTION",
                                },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Duration"),
                                isHeaderShow: true,
                                propertyName: "duration",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "null": "-",
                                        "undefined": "-"
                                    },
                                },
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Severity"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Category"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        21: "call.svg",
                                        22: "phone.svg"
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                        textAlign: "center",
                                    },
                                    column: {
                                        textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.BRAKING_EVENT_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("BRAKING_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("OCCURRED_AT"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: "Driver name",
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                propertyName: "",
                                isHeaderShow: false,
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Report Event",
                                        linkEntity: "REPORT_EVENT"
                                    },
                                    {
                                        label: "View Details",
                                        linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            }
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.ACCELERATION_EVENT_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("ACCELERATION_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("OCCURRED_AT"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: "Driver name",
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        "23": "Harsh Acceleration"
                                    },
                                },
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                propertyName: "",
                                isHeaderShow: false,
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Report Event",
                                        linkEntity: "REPORT_EVENT"
                                    },
                                    {
                                        label: "View Details",
                                        linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            }
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.CORNERING_EVENT_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("CORNERING_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("OCCURRED_AT"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("COLUMN_NAME_DriverName"),
                                isHeaderShow: true,
                                propertyName: "userName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        9: "Excess Speed",
                                        10: "Poor Technique",
                                        11: "Fast Approach",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 100,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                propertyName: "",
                                isHeaderShow: false,
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Report Event",
                                        linkEntity: "REPORT_EVENT"
                                    },
                                    {
                                        label: "View Details",
                                        linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            }
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.SPEEDING_EVENT_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("SPEEDING_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("OCCURRED_AT"),
                                isHeaderShow: true,
                                propertyName: "occurredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("SPEED"),
                                isHeaderShow: true,
                                propertyName: "speed",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("SPEED_LIMIT"),
                                isHeaderShow: true,
                                propertyName: "speedZone",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("SCHOOL_RUN_SPEEDING"),
                                isHeaderShow: true,
                                propertyName: "isSchoolRunSpeeding",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "school.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("MOTORWAY_SPEEDING"),
                                isHeaderShow: true,
                                propertyName: "isMotorWaySpeeding",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "motorway.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("DRIVING_BAN"),
                                isHeaderShow: true,
                                propertyName: "isDrivingBan",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "drivingBan.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                propertyName: "",
                                isHeaderShow: false,
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Report Event",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.REPORT_EVENT,

                                    },
                                    {
                                        label: "View Details",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",                                        
                                        linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.DISTRACTION_EVENT_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("DISTRACTION_EVENT_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("OCCURRED_AT"),
                                isHeaderShow: true,
                                propertyName: "occuredAt",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,

                                    },
                                    column: {
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("LOCATION"),
                                isHeaderShow: true,
                                propertyName: "address",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // transformation: {
                                //     type: {
                                //         to: TransformationType.OBJECT_DATA,
                                //         from: TransformationType.TEXT,
                                //     },
                                //     data: {
                                //         dataMapProperty: "address"
                                //     },
                                // },     
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("Duration"),
                                isHeaderShow: true,
                                propertyName: "duration",
                                data: {
                                    "null": "-",
                                    "undefined": "-"
                                },
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("CATEGORY"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        21: "call.svg",
                                        22: "phone.svg"
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                        textAlign: "center",
                                    },
                                    column: {
                                        textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Event"),
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: "",
                                propertyName: "",
                                isHeaderShow: false,
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Report Event",
                                        linkEntity: "REPORT_EVENT"
                                    },
                                    {
                                        label: "View Details",
                                        linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            }
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.USER_SEARCH_RESULTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("SEARCH_RESULT"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: true,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: true,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "name",
                                isAvatar: true,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 60,
                                    },
                                    column: {
                                        textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_Name"),
                                isHeaderShow: true,
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                linkTo: {
                                    userId: "userId",
                                    linkUrl: "/admin/users",
                                    linkParam: "userId",
                                    linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("COLUMN_NAME_CreatedAt"),
                                isHeaderShow: true,
                                propertyName: "registrationDate",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("ROLE"),
                                isHeaderShow: true,
                                propertyName: "userRoles",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.ARRAY_DATA,
                                    },
                                    data: {
                                        1: "System",
                                        2: "Super admin",
                                        3: "Admin",
                                        4: "User",
                                        5: "Guest",
                                        6: "Driver",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("CONTENT_STATUS"),
                                isHeaderShow: true,
                                propertyName: "contentStatus",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        "-1": "-",
                                        0: "On hold",
                                        1: "Active",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("GROUP"),
                                isHeaderShow: true,
                                propertyName: "groupName",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                // transformation: {
                                //   type: {
                                //     to: TransformationType.TEXT,
                                //     from: TransformationType.OBJECT_DATA,
                                //   },
                                //   dataMapProperty: "groupName",
                                // },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            // {
                            //   header: "Group",
                            //   propertyName: "userGroup",
                            //   isAvatar: false,
                            //   isTrendIcon: false,
                            //   isMarkerCell: false,
                            //   isDate: false,
                            //   // trendProp: null,
                            //   order: 1,
                            //   isFilterable: false,
                            //   isSortable: true,
                            //   isSorted: false,
                            //   sortedOrder: 1,
                            //   isGrouped: true,
                            //   disableGroupBy: false,
                            //   aggregate: null,
                            //   transformation: {
                            //     type: {
                            //       to: TransformationType.TEXT,
                            //       from: TransformationType.OBJECT_DATA,
                            //     },
                            //     dataMapProperty: "groupName",
                            //   },
                            //   style: {
                            //     header: {
                            //       width: 150,
                            //     },
                            //     column: {},
                            //   },
                            // },
                            {
                                header: t("MOBILE_APP_STATUS"),
                                isHeaderShow: true,
                                propertyName: "isMobileLogin",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "Logged in",
                                        false: "Not logged in",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 160,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("WELCOME_EMAIL"),
                                isHeaderShow: true,
                                propertyName: "isWelcomeEmailSent",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        1: "Sent",
                                        0: "Not sent",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "isDriver",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "View User Statistics",
                                        userId: "userId",
                                        linkUrl: "/userdetails",
                                        linkParam: "userId",
                                        linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                        isVisibleProps: "isDriver",
                                    },
                                    {
                                        label: "View User Details",
                                        userId: "userId",
                                        linkUrl: "/admin/users",
                                        linkParam: "userId",
                                        linkEntity: RBAC_CODE.ADMIN_USER_VIEW,
                                    },
                                    {
                                        label: "Edit User",
                                        userId: "userId",
                                        linkUrl: "/admin/users/edit",
                                        linkParam: "userId",
                                        linkEntity: RBAC_CODE.ADMIN_USER_EDIT_VIEW,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 60,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SPEED"),
                                isHeaderShow: true,
                                propertyName: "speed",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": " "
                                    },
                                },
                                // style: {
                                //     header: {
                                //         width: 150,
                                //     },
                                //     column: {},
                                // },
                            },
                            {
                                header: t("SPEED_LIMIT"),
                                isHeaderShow: true,
                                propertyName: "speedLimit",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": " "
                                    },
                                },
                                // style: {
                                //     header: {
                                //         width: 150,
                                //     },
                                //     column: {},
                                // },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    // header: {
                                    //     width: 150,
                                    // },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("SCHOOL_RUN_SPEEDING"),
                                isHeaderShow: true,
                                propertyName: "isSchoolRunSpeeding",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "school.svg",
                                    },
                                },
                                style: {
                                    // header: {
                                    //     width: 200,
                                    // },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("MOTORWAY_SPEEDING"),
                                isHeaderShow: true,
                                propertyName: "isMotorwaySpeeding",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "motorway.svg",
                                    },
                                },
                                style: {
                                    // header: {
                                    //     width: 160,
                                    // },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("DRIVING_BAN"),
                                isHeaderShow: true,
                                propertyName: "isDriverBan",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "drivingBan.svg",
                                    },
                                },
                                style: {
                                    // header: {
                                    //     width: 150,
                                    // },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            // {
                            //     header: "",
                            //     isHeaderShow: false,
                            //     propertyName: "eventCount",
                            //     isAvatar: false,
                            //     isTrendIcon: false,
                            //     isMarkerCell: false,
                            //     isDate: false,
                            //     // trendProp: null,
                            //     order: 1,
                            //     isFilterable: false,
                            //     isSortable: false,
                            //     isSorted: false,
                            //     sortedOrder: 1,
                            //     isGrouped: false,
                            //     disableGroupBy: true,
                            //     aggregate: null,
                            //     style: {
                            //         header: {
                            //             width: 50,
                            //         },
                            //         column: {},
                            //     },
                            // },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.APPROVED_REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("APPROVED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: true,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SPEED"),
                                isHeaderShow: true,
                                propertyName: "speed",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": " "
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("SPEED_LIMIT"),
                                isHeaderShow: true,
                                propertyName: "speedLimit",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": " "
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("SCHOOL_RUN_SPEEDING"),
                                isHeaderShow: true,
                                propertyName: "schoolrunSpeeding",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "school.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("MOTORWAY_SPEEDING"),
                                isHeaderShow: true,
                                propertyName: "motorway",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "motorway.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 160,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("DRIVING_BAN"),
                                isHeaderShow: true,
                                propertyName: "drivingBan",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "drivingBan.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.REJECTED_REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REJECTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: true,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("Speed"),
                                isHeaderShow: true,
                                propertyName: "speed",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": " "
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("Speed Limit"),
                                isHeaderShow: true,
                                propertyName: "speedLimit",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.EXCEPTION_DATA,
                                    },
                                    data: {
                                        "-1": "N/A",
                                        "null": "N/A",
                                        "undefined": " "
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {},
                                },
                            },
                            {
                                header: t("Severity"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("School run Speeding"),
                                isHeaderShow: true,
                                propertyName: "schoolrunSpeeding",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "school.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("Motorway Speeding"),
                                isHeaderShow: true,
                                propertyName: "motorway",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "motorway.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 160,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: t("Driving Ban"),
                                isHeaderShow: true,
                                propertyName: "drivingBan",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        true: "drivingBan.svg",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.BRAKING_REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.CORNERING_REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.ACCELERATION_REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.DISTRACTION_REPORTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: "Duration",
                                isHeaderShow: true,
                                propertyName: "duration",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 2,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "ExceptionData"
                                    },
                                    data: {
                                        null: "-",
                                        undefined: "-"
                                    }
                                },
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "duration"
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.BRAKING_APPROVED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.CORNERING_APPROVED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.ACCELERATION_APPROVED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.DISTRACTION_APPROVED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: "Duration",
                                isHeaderShow: true,
                                propertyName: "duration",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 2,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "ExceptionData"
                                    },
                                    data: {
                                        null: "-",
                                        undefined: "-"
                                    }
                                },
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "duration"
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.BRAKING_REJECTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.CORNERING_REJECTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.ACCELERATION_REJECTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.DISTRACTION_REJECTED_EVENTS) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("REPORTED_EVENTS"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DRIVER_INVOLVED"),
                                isHeaderShow: true,
                                // propertyName: "datename",
                                propertyName: "name",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                // linkTo: {
                                //     userId: "userId",
                                //     linkUrl: "/admin/users",
                                //     linkParam: "userId",
                                //     linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                                // },
                                style: {
                                    header: {
                                        width: 300,
                                    },
                                    column: {
                                        whiteSpace: "nowrap",
                                    },
                                },
                            },
                            {
                                header: "Duration",
                                isHeaderShow: true,
                                propertyName: "duration",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 2,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "ExceptionData"
                                    },
                                    data: {
                                        null: "-",
                                        undefined: "-"
                                    }
                                },
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "duration"
                            },
                            {
                                header: t("SEVERITY"),
                                isHeaderShow: true,
                                propertyName: "severity",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.IMAGE,
                                        from: TransformationType.BOOLEAN,
                                    },
                                    data: {
                                        3: "severeEvents.png",
                                    },
                                },
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            {
                                header: "Event",
                                isHeaderShow: true,
                                propertyName: "eventTypeId",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                isRequired: false,
                                order: 3,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: false,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: "Text",
                                        from: "Enum"
                                    },
                                    data: {
                                        6: "Harsh Braking",
                                        7: "Brake Overuse",
                                        8: "Tailgating"
                                    }
                                },
                                style: {
                                    header: {
                                        width: 200
                                    },
                                    column: {}
                                },
                                columnCode: "eventTypeId"
                            },
                            {
                                header: "",
                                isHeaderShow: false,
                                propertyName: "",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isAction: true,
                                actionOptions: [
                                    {
                                        label: "Approve",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                    {
                                        label: "Reject",
                                        // userId: "userId",
                                        // linkUrl: "/admin/users/edit",
                                        // linkParam: "userId",
                                        linkEntity: RBAC_CODE.VERIFY_EVENT,
                                    },
                                ],
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: false,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 50,
                                    },
                                    column: {},
                                },
                            },
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.DRIVER_MILEAGE_CLAIM_LIST) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        } else {
            data.content = [
                {
                    id: "1",
                    tableName: t("MILEAGE_CLAIM_LIST"),
                    isFavourite: true,
                    isDefault: true,
                    tableConfiguration: {
                        pageLengthArray: [10, 20, 50, 100, 500],
                        defaultPageSize: 10,
                        isGlobalFilterEnable: false,
                        globalFilterPlaceholder: placeholder,
                        isGroupByEnable: false,
                        isAccordionEnable: false,
                        showPagination: true,
                        columns: [
                            {
                                header: t("DATE"),
                                isHeaderShow: true,
                                propertyName: "daterange",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,

                                    },
                                    column: {
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("DISTANCE"),
                                isHeaderShow: true,
                                propertyName: "distanceInMiles",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 200,
                                    },
                                    column: {
                                        // textAlign: "center",
                                    },
                                },
                            },
                            {
                                header: t("CLAIMED_ON"),
                                isHeaderShow: true,
                                propertyName: "createdOn",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: true,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                style: {
                                    header: {
                                        width: 150,
                                    },
                                    column: {
                                        fontWeight: 500,
                                    },
                                },
                            },
                            {
                                header: t("STATUS"),
                                isHeaderShow: true,
                                propertyName: "status",
                                isAvatar: false,
                                isTrendIcon: false,
                                isMarkerCell: false,
                                isDate: false,
                                isHidden: false,
                                // trendProp: null,
                                order: 1,
                                isFilterable: false,
                                isSortable: true,
                                isSorted: false,
                                sortedOrder: 1,
                                isGrouped: false,
                                disableGroupBy: true,
                                aggregate: null,
                                transformation: {
                                    type: {
                                        to: TransformationType.TEXT,
                                        from: TransformationType.ENUM,
                                    },
                                    data: {
                                        1: t('CLAIMED'),
                                        2: t('APPROVED'),
                                        3: t('REJECTED')
                                    },
                                },
                                style: {
                                    header: {
                                        width: 150,
                                        textAlign: "center",
                                    },
                                    column: {
                                        textAlign: "center",
                                        pointerEvents: "none",
                                    },
                                },
                            },
                            // {
                            //     header: t("COLUMN_NAME_Event"),
                            //     isHeaderShow: true,
                            //     propertyName: "eventTypeId",
                            //     isAvatar: false,
                            //     isTrendIcon: false,
                            //     isMarkerCell: false,
                            //     isDate: false,
                            //     isHidden: true,
                            //     // trendProp: null,
                            //     order: 1,
                            //     isFilterable: false,
                            //     isSortable: false,
                            //     isSorted: false,
                            //     sortedOrder: 1,
                            //     isGrouped: false,
                            //     disableGroupBy: true,
                            //     aggregate: null,
                            //     style: {
                            //         header: {
                            //             width: 150,
                            //         },
                            //         column: {
                            //             // textAlign: "center",
                            //         },
                            //     },
                            // },
                            // // {
                            // //     header: "",
                            // //     propertyName: "",
                            // //     isHeaderShow: false,
                            // //     isAvatar: false,
                            // //     isTrendIcon: false,
                            // //     isMarkerCell: false,
                            // //     isDate: false,
                            // //     isAction: true,
                            // //     actionOptions: [
                            // //         {
                            // //             label: "Report Event",
                            // //             linkEntity: "REPORT_EVENT"
                            // //         },
                            // //         {
                            // //             label: "View Details",
                            // //             linkEntity: RBAC_CODE.USER_DETAIL_VIEW,
                            // //         },
                            // //     ],
                            // //     // trendProp: null,
                            // //     order: 1,
                            // //     isFilterable: false,
                            // //     isSortable: false,
                            // //     isSorted: false,
                            // //     sortedOrder: 1,
                            // //     isGrouped: false,
                            // //     disableGroupBy: true,
                            // //     aggregate: null,
                            // //     style: {
                            // //         header: {
                            // //             width: 50,
                            // //         },
                            // //         column: {},
                            // //     },
                            // // }
                        ],
                    },
                },
            ];
        }
    } else if (type === TableComponentCodes.MILEAGE_CLAIMED) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        }
    } else if (type === TableComponentCodes.MILEAGE_APPROVED) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        }
    } else if (type === TableComponentCodes.MILEAGE_REJECTED) {
        if (userData && userData.userRoleId !== Role.DRIVER && !params.impersonationid) {
            const result = await getTableSettings(userData, url, t, params);
            data.content = result;
        }
    }
    return data;
};


export const getNewView = async (params: any) => {
    let ApiUrl = `${APIURL.TABLE_COMPONENT_NEW_VIEW}?tcCode=${params.tcId}`;
    if (params.tcAction !== DragNDrop.CREATE) {
        ApiUrl = `${ApiUrl}&tcViewId=${params.tcViewId}`
    }
    const token = getToken()
    try {
        const response = await PraisoServices(
            ApiUrl,
            "get",
            {},
            {},
            {
                Authorization: `Bearer ${token}`
            }
        );
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const createNewView = async (request: any) => {
    let ApiUrl = `${APIURL.TABLE_COMPONENT_CREATE_NEW_VIEW}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "post", { ...request }, {}, { Authorization: `Bearer ${token}` });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return { status: { code: 1, message: err.message, }, content: null };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return { status: { code: 1, message: err.message, }, content: null };
    }
};

export const updateView = async (request: any, tcViewId: number, params: any) => {
    let ApiUrl = `${APIURL.TABLE_COMPONENT_UPDATE_NEW_VIEW}${tcViewId}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "patch", { ...request }, {}, { Authorization: `Bearer ${token}` });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return { status: { code: 1, message: err.message, }, content: null };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return { status: { code: 1, message: err.message, }, content: null };
    }
};

export const copyView = async (tcViewId: number, viewName: string) => {
    let ApiUrl = `${APIURL.TABLE_COMPONENT_COPY_VIEW}${tcViewId}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "post", { "viewName": viewName }, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return { status: { code: 1, message: err.message, }, content: null };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return { status: { code: 1, message: err.message, }, content: null };
    }
};

export const changeView = async (request: any) => {
    let ApiUrl = APIURL.TABLE_COMPONENT_CHANGE_VIEW;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "post", { ...request }, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return { status: { code: 1, message: err.message, }, content: null };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return { status: { code: 1, message: err.message, }, content: null };
    }
};

export const reportEvent = async (request: any) => {
    let ApiUrl = APIURL.EVENT_MANAGEMENT_REPORT_EVENT;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "post", { ...request }, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const approveRejectEvent = async (request: any, id: number) => {
    let ApiUrl = `${APIURL.EVENT_MANAGEMENT_APPROVE_REJECT}${id}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "post", { ...request }, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const getAllReportEvent = async () => {
    // window.localStorage.removeItem("API");
    let ApiUrl = APIURL.EVENT_MANAGEMENT_REPORT_EVENT;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "get", {}, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const getEventDetail = async (params: any) => {
    const isReportedEvent = params.reportStatus === ReportedEventStatus.No_REPORTED_EVENT ? ReportedEventStatus.NO_REPORT : ReportedEventStatus.REPORTED;
    let ApiUrl = `${APIURL.EVENT_MANAGEMENT_APPROVE_REJECT}${params.eventId}?userId=${params.userId}&isReportedEvent=${isReportedEvent}`;
    if (params.reportStatus !== undefined && params.reportStatus !== null && params.reportStatus == ReportedEventStatus.DISTRACTION_EVENT) {
        ApiUrl = `${APIURL.EVENT_MANAGEMENT_APPROVE_REJECT}${params.eventId}?userId=${params.userId}&isDistractionEvent=1`;
    }
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "get", {}, {}, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};

export const getReportList = async (id: number, eventType?: string) => {
    let ApiUrl = `${APIURL.EVENT_MANAGEMENT_REPORT_EVENT}?reportStatus=${id}`;
    const token = getToken();
    try {
        const response = await PraisoServices(ApiUrl, "get", {}, { "eventTypeId": eventType }, { Authorization: `Bearer ${token}`, });
        try {
            return response;
        } catch (error) {
            const err = error as Error;
            return {
                status: {
                    code: 1,
                    message: err?.message,
                },
                content: null,
            };
        }
    } catch (error_1) {
        const err = error_1 as Error;
        return {
            status: {
                code: 1,
                message: err.message,
            },
            content: null,
        };
    }
};